// Specchio lato client della ALLOWLIST del backend
// (middlewares/auth_middleware.py -> ACT_AS_ALLOWED_ENDPOINTS).
//
// Serve perche' fuori da quelle rotte l'header X-Act-As non viene ignorato: viene
// RIFIUTATO con 403. Mandandolo ovunque, durante una delega si romperebbero GET /account
// (e quindi sidebar, ruolo e banner), le notifiche e lo shop — cioe' il guscio
// dell'applicazione. Qui si evita solo di mandarlo dove si sa gia' che verrebbe rifiutato:
// la decisione su chi puo' delegare e su cosa resta interamente del backend.
//
// Conseguenza voluta: durante una delega, profilo, abbonamenti e Stripe restano
// dell'OPERATORE. Un acquisto non finisce mai sull'account del cliente per distrazione.
// Per lo stesso motivo la sidebar NON diventa quella del cliente: /account non e'
// delegabile, quindi ruolo e navigazione restano quelli dell'operatore.
//
// METODO E PATH, non solo il path: sul backend un endpoint copre tutti i metodi con cui e'
// registrato, e la delega in fase 1 concede solo lettura e creazione. "/searches" con DELETE
// cancellerebbe le ricerche del cliente: l'header non deve nemmeno partire.
//
// Path esatti (niente prefissi): "/searches" e' delegabile, "/searches/auto/config"
// (ASConfiguration) no, e un match per prefisso li confonderebbe.
const ACT_AS_ALLOWED: Record<string, string[]> = {
  "/legalPractices": ["GET", "POST"], // routes/LegalPractices.py:11 (pratiche del cliente)
  // Solo GET: la POST fa partire una ricerca su SFM, che oggi la intesterebbe
  // all'operatore mentre il credito lo paga il cliente (APIs/SFM.py).
  "/searches": ["GET"], // routes/Search.py:11
  "/searches/cost": ["GET"], // routes/Search.py:29
  // Import link da Excel/CSV: solo accodamento al JSON della ricerca del cliente,
  // nessun credito e nessuna ricerca SFM.
  "/searches/import/parse": ["POST"], // routes/Search.py (anteprima del file)
  "/searches/import": ["POST"], // routes/Search.py
  "/files/csv": ["GET", "POST"], // routes/File.py:12
  "/files/legal_evidence": ["GET", "POST"], // routes/File.py:29 (report di prova)
  "/files/download": ["GET"], // routes/File.py:47
  "/urls": ["GET"], // routes/SignaledUrls.py:11 (URL segnalati)
  // Resoconto per periodo del cliente. Il PDF (/stats/period/report) resta fuori: e' solo
  // per operatori e parte con user_id esplicito.
  "/stats/period": ["GET"],
};

export const isActAsAllowedRequest = (
  url?: string,
  method?: string
): boolean => {
  if (!url) return false;
  // Gli url passati a codeHttpClient sono relativi al baseURL e possono portare la
  // query attaccata ("/legalPractices?practice_id=12") o essere senza slash iniziale
  // ("admin/legalPractices?...", practice.api.ts:36).
  const path = url.split("?")[0].split("#")[0];
  const normalized = (path.startsWith("/") ? path : `/${path}`).replace(
    /\/+$/,
    ""
  );
  const allowed = ACT_AS_ALLOWED[normalized];
  if (!allowed) return false;
  // axios normalizza il metodo in minuscolo e lo omette quando e' GET.
  return allowed.includes((method || "get").toUpperCase());
};
